import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahBudgets } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { DashboardBudgetsResponse } from '~support-at-home/models/dashboard';

export type DashboardBudgetsReq = {
  quarter: number;
  year: number;
};

export const dashboardBudgetsApi = createApi({
  reducerPath: 'dashboardBudgetsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahBudgets }),
  tagTypes: ['dashboard-budgets'],
  endpoints: (builder) => ({
    getDashboardBudgets: builder.query<DashboardBudgetsResponse, DashboardBudgetsReq>({
      query: (params) => ({
        url: '/dashboard',
        method: 'GET',
        params: { quarter: `Q${params.quarter}`, year: params.year },
      }),
      providesTags: [{ type: 'dashboard-budgets', id: 'LIST' }],
      transformResponse: (payload) => unwrap<DashboardBudgetsResponse>(payload),
    }),
  }),
});

export const { useGetDashboardBudgetsQuery } = dashboardBudgetsApi;
